import type {
  OrderConfirmationAppliedDiscountBanner,
  OrderConfirmationAppliedDiscountData,
} from '@library/api-customer-engagement-experience'

import { useOrderConfirmationBanners } from './useOrderConfirmationBanners'

export type UseAppliedDiscountBannerResult =
  | { status: 'none' }
  | { status: 'banner'; data: OrderConfirmationAppliedDiscountData }

// Loading, error and empty all fold into 'none': nothing renders, and no space is reserved,
// until a usable applied_discount item exists.
export const useAppliedDiscountBanner = (orderId: string): UseAppliedDiscountBannerResult => {
  const { data, error } = useOrderConfirmationBanners(orderId)

  if (error || !data) {
    return { status: 'none' }
  }

  const banner = data.find(
    (item): item is OrderConfirmationAppliedDiscountBanner => item.type === 'applied_discount',
  )

  return banner ? { status: 'banner', data: banner.data } : { status: 'none' }
}
